<template>
    <div id="app">
        <nav class="navbar navbar-dark fixed-top bg-dark flex-md-nowrap p-0 shadow">
            <a class="navbar-brand col-sm-3 col-md-2 mr-0" href="/dashboard">Taurus Insurance Services</a>
            <input class="form-control form-control-dark w-100" type="text" placeholder="Search" aria-label="Search">
            <ul class="navbar-nav px-3">
                <li class="nav-item text-nowrap">
                    <a class="nav-link" href="javascript:void(0)" @click="logOut()">Sign out</a>
                </li>
            </ul>
        </nav>

        <div class="container-fluid">
            <transition name="fade">
                <div v-if="showSidebar == true" class="row">
                    <side-bar v-on:toggle-clicked="sidebarToggleClicked"/>

                    <main role="main" class="col-md-9 ml-sm-auto col-lg-10 px-4">
                        <router-view :key="$route.fullPath" />
                    </main>
                </div>
                <div v-else class="row">
                    <div v-if="!isPopout" class="sidebar bg-light" style="width:20px">
                        <i :class="showSidebarIcon" @click="manShowSidebar = !manShowSidebar" v-b-tooltip.hover.right title="Show menu"></i>
                    </div>
                    <main role="main" class="col-md-12 ml-sm-auto col-lg-12 px-4">
                        <router-view :key="$route.fullPath" />
                    </main>
                </div>
            </transition>
        </div>
        <toast />
    </div>
</template>

<script>
    import Sidebar from '@/components/Sidebar.vue'
    import authentication from '@/util/authentication'
    import Toast from '@/components/toast.vue'

    export default {
        components: {
            'side-bar': Sidebar,
            'toast': Toast
        },
        data: () => {
            return {
                manShowSidebar: true
            }
        },
        beforeCreate() {
            this.$store.commit('initialise')
            this.$store.dispatch('appSettings/fetchClaimPaymentsEnabled')
            this.$store.dispatch('appSettings/fetchRunPipelinesEnabled')
        },
        computed: {
            showSidebar() {
                return this.$route.query.sidebar ? this.$route.query.sidebar : this.manShowSidebar; //show sidebar by default
            },
            showSidebarIcon() {
                if (this.manShowSidebar) {
                    return 'fas fa-angle-double-left'
                } else {
                    return 'fas fa-angle-double-right'
                }
            },
            isPopout() {
                return this.$route.query.sidebar ? this.$route.query.sidebar : false
            }
        },
        methods:
        {
            logOut() {
                authentication.signOut();
            },
            sidebarToggleClicked(val) {
                this.manShowSidebar = val[0]
            }
        }
    }

</script>

<style>
    .sidebarmin {

    }
</style>
